import { defineAction } from '~/prix'
import { z } from 'zod'
import trainingPerformedDeleteAction from './trainingPerformedDelete.action.json' with { type: 'json' }
import { trainingPerformedObject } from '../trainingPerformedObject'
import { dateOrIsoString } from '~/prix/types/date'

const trainingPerformedDeleteDefinition = defineAction({
  ...trainingPerformedDeleteAction,

  input: z.object({ id: trainingPerformedObject.shape.id, updatedAt: dateOrIsoString().nullish() }),
  output: z.object({}),
})

export default trainingPerformedDeleteDefinition
